import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {LayoutFullWidth} from "../../../../Components/Layout";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {loanLibraryLoanApi} from "../LoanLibraryLoan/loanLibraryLoanApi";
import {LoanLibraryHistoryView} from "./LoanLibraryHistoryView";
import {LoanLibraryHistorySearchFormView} from "./LoanLibraryHistorySearchFormView";
import {loanLibraryHistory} from "./loanLibraryHistoryFactory";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {loanLibraryLoanReportApi} from "../../../Loan/LoanLibrary/LoanManagement/loanLibraryLoanApi";

export const LoanLibraryHistoryContainer = ({
    handleApiCall,
    handleSetLoanLibraryHistorySearchCriteria,
    isLoading,
    loanLibraryHistorySearchCriteria,
}: ContextProps) => {
    const [loanHistories, setLoanHistories] = useState<Record<string, any>[]>([]);
    const [dropDowns, setDropDowns] = useState<Record<string, unknown> | null>(null);
    const [totalRecords, setTotalRecords] = useState(0);

    const loadLoanHistoriesResults = (result: { items: Record<string, any>[]; totalCount: number }) => {
        const histories = result.items.map((history: Record<string, any>) => loanLibraryHistory(history));
        setLoanHistories(histories);
        setTotalRecords(result.totalCount);
    };

    const handleGetDropDowns = () => {
        handleApiCall(() => loanLibraryLoanApi.getDropdownListsForLoanLibraryLoanSearch(), (results: Record<string, unknown>) => setDropDowns(results));
    };

    const handleExportLoansClick = () => {
        if (isArrayNullOrEmpty(loanHistories)) {
            alert("Search criteria has no results. Adjust your search and try again.")
        }
        else
            handleApiCall(() => loanLibraryLoanReportApi.getLoanLibraryLoanHistoryExport(loanLibraryHistorySearchCriteria));
    };

    useEffect(() => {
        if (!dropDowns) {
            handleGetDropDowns();
        }

        if (loanLibraryHistorySearchCriteria.loadSearchResults) {
            handleApiCall(
                () => loanLibraryLoanApi.getLoanHistory({...loanLibraryHistorySearchCriteria}),
                loadLoanHistoriesResults
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loanLibraryHistorySearchCriteria]);

    if (!loanLibraryHistorySearchCriteria || isNullOrUndefined(dropDowns)) return null;

    return (
        <>
            <PageTitle h1="Loan Library History" />

            {
                dropDowns && (
                <div className="searchBox">
                    <div className="searchBox__title">Search Loan History</div>
                    <LoanLibraryHistorySearchFormView
                        dropDowns={dropDowns}
                        handleSetSearchCriteria={handleSetLoanLibraryHistorySearchCriteria}
                        isLoading={isLoading}
                        searchCriteria={loanLibraryHistorySearchCriteria}
                    />
                </div>
            )}
            <LayoutFullWidth className="catalog">
                <header>
                    <h2>Loan History Results</h2>
                </header>

                <GridContainer isReverseOrder className={`form__header`} hasMarginX>
                    <GridCell
                        medium_columns={gridConstants.column.THREE}>
                        <ButtonLinkStyle
                            isCollapsed
                            label={`Export Loan Library Loans`}
                            name="btnExportLoans"
                            onClick={handleExportLoansClick}
                        />
                    </GridCell>
                </GridContainer>

                <LoanLibraryHistoryView
                    handleSetSearchCriteria={handleSetLoanLibraryHistorySearchCriteria}
                    loanHistories={loanHistories}
                    searchCriteria={loanLibraryHistorySearchCriteria}
                    totalRecords={totalRecords}
                />
            </LayoutFullWidth>
        </>
    );
};
